import tinycolor from 'tinycolor2';

const colorGenerationSteps = [
  { name: 50, mix: ['white', 95], sat: -20, light: +2 },
  { name: 100, mix: ['white', 90], sat: -18, light: +1 },
  { name: 200, mix: ['white', 80], sat: -14, light: 0 },
  { name: 300, mix: ['white', 70], sat: -10, light: 0 },
  { name: 400, mix: ['white', 60], sat: -6, light: -1 },
  { name: 500, mix: [null, 0], sat: 0, light: 0 },
  { name: 600, mix: ['black', 10], sat: +4, light: -1 },
  { name: 700, mix: ['black', 20], sat: +8, light: -1 },
  { name: 800, mix: ['black', 30], sat: +12, light: -2 },
  { name: 900, mix: ['black', 45], sat: +16, light: -3 },
  { name: 950, mix: ['black', 60], sat: +20, light: -4 },
];

const SHADE_LEVELS = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950];

const setThemeProperty = (key, value) => {
  document.documentElement.style.setProperty(key, value);
};

const applyShadeProperties = (property_prefix, shades, shade_prefix) => {
  SHADE_LEVELS.forEach((shade) => {
    setThemeProperty(`${property_prefix}${shade}`, shades[`${shade_prefix}${shade}`] || shades[shade]);
  });
};

const generateColorShades = (baseColor, formatter) => {
  const startColor = tinycolor(baseColor);
  return colorGenerationSteps.reduce((shades, step) => {
    let color = startColor.clone();
    if (step.mix[0]) {
      color = tinycolor.mix(color, step.mix[0], step.mix[1]);
    }
    if (step.sat !== 0) {
      color = step.sat > 0 ? color.saturate(step.sat) : color.desaturate(-step.sat);
    }
    if (step.light !== 0) {
      color = step.light > 0 ? color.lighten(step.light) : color.darken(-step.light);
    }
    shades[step.name] = formatter(color);
    return shades;
  }, {});
};

export const generateColorShadesHex = (baseColor) => generateColorShades(baseColor, (c) => c.toHexString());

export const generateColorShadesRgb = (baseColor) => generateColorShades(baseColor, (c) => `${c._r}, ${c._g}, ${c._b}`);

export const extractThemeColors = (theme_primary_color) => {
  const hslColor = tinycolor(theme_primary_color).toHsl();
  const rgbColor = tinycolor(theme_primary_color).toRgb();

  return {
    h: hslColor.h,
    s: hslColor.s * 100,
    l: hslColor.l * 100,
    hex: theme_primary_color,
    rgb: rgbColor,
    shadesHex: generateColorShadesHex(theme_primary_color),
    shadesRgb: generateColorShadesRgb(theme_primary_color),
  };
};

export const applyThemeColors = (colorData) => {
  // Set HSL values
  setThemeProperty('--bulma-primary-h', colorData.h);
  setThemeProperty('--bulma-primary-s', `${colorData.s}%`);
  setThemeProperty('--bulma-primary-l', `${colorData.l}%`);

  // Set hex shades
  const hexShades = colorData.shadesHex || colorData;
  applyShadeProperties('--p-primary-', hexShades, 'hex_');

  // Set RGB shades
  const rgbShades = colorData.shadesRgb || colorData;
  applyShadeProperties('--primary-', rgbShades, 'rgb_');
};

export const applyTheme = (theme_primary_color) => {
  const colorData = extractThemeColors(theme_primary_color);
  applyThemeColors(colorData);
};
